import { capitalize } from 'lodash';
import type { FilterKeys } from '../../../quick-search/types';
import type { SectionId } from '../../types';
import { LEXICAL_SECTION_ID, NLP_SECTION_ID } from '../../types';
import type { TrackFilterType, TrackTabSelected } from './types';

/**
 * Get the time elapsed in seconds between two timestamps
 * @param startMs - The start timestamp in milliseconds
 * @param endMs - The end timestamp in milliseconds
 * @returns The time elapsed in seconds
 */
export function getTimeElapsedInSeconds(startMs: number, endMs: number) {
  return ((endMs - startMs) / 1000).toPrecision(3);
}

/**
 * Get the exit method based on the event type
 * @param methodType - The type of event that triggered the exit
 * @returns The exit method
 */
export function getExitMethod(methodType: 'keydown' | 'mousedown') {
  return methodType === 'keydown' ? 'Esc' : 'ClickAway';
}

/**
 * Get the filter types based on the filter and filters map
 * @param filter - The filter to get the types for
 * @param filtersMap - The filters map
 * @returns The filter types
 */
export function getTabSelected(
  sectionId: SectionId | null | undefined
): TrackTabSelected | undefined {
  if (sectionId === LEXICAL_SECTION_ID) return 'Standard';
  if (sectionId === NLP_SECTION_ID) return 'AI';
  return undefined;
}

export const getFilterTypes = (
  filtersMap: Record<FilterKeys, boolean>,
  filter?: FilterKeys
) => {
  const existingFilters = Object.keys(filtersMap).filter((f) =>
    Boolean(filtersMap[f as FilterKeys])
  );
  return (filter ? [...existingFilters, filter] : existingFilters).map(
    capitalize
  ) as TrackFilterType[];
};
